<main class="main">
  <app-header></app-header>
  <app-version-banner />
  <router-outlet />
</main>

<!-- <app-help-button /> -->

@if (searchState.isOpen()) {
<div
  appEscapeListener
  (escape)="searchState.close()"
  (click)="searchState.close()"
  class="search-sum-card-container-backdrop"
  [@backdropAnimation]
></div>

<div class="search-sum-card-container-floating pb-sm" [@searchPanelAnimation] (click)="$event.stopPropagation()">
  <app-search-data></app-search-data>
</div>
}

<app-floating-badge></app-floating-badge>
